import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13 19H2v-1h11v1zm3.986-6.008v-11h-1v11h1zm-1.814.224l-5.5-9.526-.866.5 5.5 9.526.865-.5zm-1.459 1.101l-9.526-5.5-.5.866 9.526 5.5.5-.865zM13 16H2v1h11v-1z',
  ],
  height: 20,
  width: 20,
});
